var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn section btn-block btn-outline-primary",class:{
    'opacity-50': _vm.section.deleted
  }},_vm.$listeners),[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.section.title))]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.section.short_description))])])}
var staticRenderFns = []

export { render, staticRenderFns }